import { ApiError } from '../services/whatsappApi';

/**
 * The backend answers 403 `feature_unavailable` to clinics that are not on its
 * WHATSAPP_DEMO list. Callers decide by `code`, as with every other API error.
 */
export const isFeatureUnavailable = (err: unknown): boolean =>
  err instanceof ApiError && err.status === 403 && err.code === 'feature_unavailable';

export const COMING_SOON_TITLE = 'La bandeja de WhatsApp llega pronto';
export const COMING_SOON_TEXT = 'Estamos preparando el asistente que responderá a tus pacientes por WhatsApp.';
